// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"121":"gallery","548":"calendar"}[chunkId] + "-legacy." + {"121":"294c14da","548":"28464341"}[chunkId] + ".js";
};